import Block from "../components/Block";
import Carousel from "../components/Carousel";
import EmbedBlock from "../components/EmbedBlock";
import Footer from "../components/Footer";
import Heading from "../components/Heading";
import Image from "../components/Image";
import ImageBlock from "../components/ImageBlock";
import Layout from "../components/Layout";
import ProjectNav from "../components/ProjectNav";
import ResponsiveImageBlock from "../components/ResponsiveImageBlock";
import RichTextBlock from "../components/RichTextBlock";
import classNames from "classnames/bind";
import gridStyle from "../components/Grid.module.css";
import styles from "./ProjectPage.module.css";

export default function ProjectPage({ coreData, pageData, pathName }) {
  return (
    <Layout
      style={{ "--bg": pageData.backgroundColor }}
      theme={pageData.foregroundColor === "light" ? "dark" : "light"}
      coreData={coreData}
      pathName={pathName}
    >
      <div className={styles.heroSection}>
        <div className={styles.hero}>
          <Heading className={styles.heroHeading}>{pageData.title}</Heading>
          <Image
            src={pageData.heroImage.src}
            srcSet={pageData.heroImage.srcSet}
            sizes="100vw"
            alt={pageData.heroImage.title}
            width={800}
            height={450}
            className={styles.heroImage}
          />
        </div>
      </div>
      <div className={classNames(styles.detailsSection, gridStyle.grid)}>
        <div className={styles.overview}>
          <div className={styles.overviewItem}>
            <p>Client:</p>
            <p className={styles.attrValue}>{pageData.client}</p>
          </div>
          <div className={styles.overviewItem}>
            <p>Project type:</p>
            {pageData.projectTypeNames.map((projectTypeName, index) => (
              <p key={`project-type-${index}`} className={styles.attrValue}>
                {projectTypeName}
              </p>
            ))}
          </div>
          {pageData.agency && (
            <div className={styles.overviewItem}>
              <p>Agency:</p>
              <p className={styles.attrValue}>{pageData.agency}</p>
            </div>
          )}
          {pageData.credits?.length > 0 && (
            <div className={styles.overviewItem}>
              <p>Credits:</p>
              {pageData.credits.map((block, index) =>
                block.value.website ? (
                  <a
                    key={index}
                    href={block.value.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.attrValue}
                  >
                    {block.value.name}
                  </a>
                ) : (
                  <p key={index} className={styles.attrValue}>
                    {block.value.name}
                  </p>
                ),
              )}
            </div>
          )}
          {pageData.link && (
            <div className={styles.overviewItem}>
              <p>View:</p>
              <a
                href={pageData.link}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.attrValue}
              >
                {pageData.link.replace("http://", "").replace("https://", "")}
              </a>
            </div>
          )}
        </div>
        <div
          className={styles.detailsText}
          dangerouslySetInnerHTML={{ __html: pageData.heroText }}
        />
      </div>
      <div className={styles.content}>
        {pageData.pageContent.map((block, index) => {
          if (block.type === "image_block") {
            return (
              <Block key={index}>
                <ImageBlock value={block.value} />
              </Block>
            );
          }
          if (block.type === "responsive_image_block") {
            return (
              <Block key={index}>
                <ResponsiveImageBlock
                  imgDesktop={block.value.imgDesktop}
                  imgMobile={block.value.imgMobile}
                />
              </Block>
            );
          }

          if (block.type === "embed_block") {
            return (
              <Block key={index}>
                <EmbedBlock value={block.value} />
              </Block>
            );
          }

          if (block.type === "image_carousel_block") {
            return (
              <Block key={index}>
                <Carousel items={block.value} />
              </Block>
            );
          }

          if (block.type === "rich_text_block") {
            return (
              <Block key={index}>
                <RichTextBlock value={block.value} />
              </Block>
            );
          }
        })}
      </div>
      <div className={styles.quickNavAndFooter}>
        <ProjectNav
          prevProject={pageData.prevProject}
          nextProject={pageData.nextProject}
        />
        <Footer />
      </div>
    </Layout>
  );
}
